import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Tworzenie nowej oferty',
  subtitle: 'Jak klient otrzymuje darmową pozycję?',
  validation: {
    required: 'Wybierz typ oferty',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Łączna wartość zamówienia',
      description: 'Np. 10% zniżki na zamówienie przy wydaniu 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Wybrane pozycje',
      description: 'Np. 10% zniżki na pizze 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Wybrane pozycje',
      description: 'Np. 1 {{currency}} zniżki na pizze 30 cm.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Łączna wartość zamówienia',
      description: 'Np. 1 {{currency}} zniżki na zamówienie przy wydaniu 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Kup 1, dostań 1 gratis',
      description: 'Np. Kup 1 pizzę i dostań drugą gratis. Tańsza pizza jest objęta rabatem.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Kup 1, dostań 1 w połowie ceny',
      description: 'Np. Kup 1 pizzę i dostań drugą w połowie ceny, tańsza pizza jest objęta rabatem.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Kupując inną pozycję',
      description: 'Np. Dostań darmowy napój przy zamówieniu posiłku.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Przy wydaniu stałej kwoty {{currency}}',
      description: 'Np. Dostań darmowy deser przy wydaniu 20 {{currency}}.',
    },
  },
};
